import React from 'react';
import type { AdapterStatus } from '../../data/integrations';
const map: Record<AdapterStatus, {
  label: string;
  cls: string;
}> = {
  not_configured: {
    label: 'Missing',
    cls: 'bg-ink-100 text-ink-700 border-ink-300'
  },
  pending_credentials: {
    label: 'Missing — credentials',
    cls: 'bg-white text-ink-700 border-ink-400 border-dashed'
  },
  external_required: {
    label: 'Missing — external server',
    cls: 'bg-magenta-soft text-magenta-dark border-magenta/30'
  },
  in_review: {
    label: 'In review',
    cls: 'bg-white text-ink-700 border-ink-400'
  },
  failed: {
    label: 'Failed / incomplete',
    cls: 'bg-magenta text-white border-magenta'
  },
  connected_untested: {
    label: 'Connected, not tested',
    cls: 'bg-lime-soft text-lime-dark border-lime-dark/30'
  },
  connected_tested: {
    label: 'Connected and tested',
    cls: 'bg-lime text-ink border-lime'
  }
};
export function StatusBadge({
  status
}: {
  status: AdapterStatus;
}) {
  const s = map[status];
  return <span className={`inline-flex whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-semibold ${s.cls}`} data-id="element-359" data-mp="mhfv3h6t7api">{s.label}</span>;
}